import { render, staticRenderFns } from "./maquinas.vue?vue&type=template&id=5cff492c&scoped=true"
import script from "./maquinas.vue?vue&type=script&lang=js"
export * from "./maquinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff492c",
  null
  
)

export default component.exports